import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPositionV2ById } from './positionV2';

export function getUsePositionV2QueryKey(positionId: string) {
    return ['positionV2', positionId];
}

type QueryOptionsParams = [
    positionId: string,
    {
        fetchOnce?: boolean;
    }?,
];

export const useGetPositionV2QueryOptions = () => {
    const { getPositionV2ById } = useGetPositionV2ById();

    return (positionId: QueryOptionsParams[0], { fetchOnce = false }: QueryOptionsParams[1] = {}) => ({
        queryKey: getUsePositionV2QueryKey(positionId),
        queryFn: () => getPositionV2ById(positionId),
        ...(fetchOnce && { staleTime: Infinity, cacheTime: Infinity }),
    });
};

export const usePositionV2 = (...params: QueryOptionsParams) => {
    const getQueryOptions = useGetPositionV2QueryOptions();
    return useSuspenseQuery(getQueryOptions(...params));
};
